import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Customer } from 'src/app/models/customer';
import { WorkorderService } from 'src/app/services/workorder.service';

@Component({
  selector: 'app-past-participation-dialog',
  templateUrl: './past-participation-dialog.component.html',
  styleUrls: ['./past-participation-dialog.component.scss']
})
export class PastParticipationDialogComponent implements OnInit {

  loadWorkorder: boolean = true;
  programs: Program[] = [];
  isDataFound: string='';

  constructor(
    public dialogRef: MatDialogRef<PastParticipationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { row: Customer },
    private workorderService: WorkorderService,
  ) {
  
    this.workorderService.addCustomerPastParticipation(data.row.AccountNumber).subscribe(res => {
      if (res.length) {
        this.programs = res;
        this.loadWorkorder = false;
      } else {
        this.isDataFound = "No past participation data found";
        this.loadWorkorder = false;
      }
    })
  }


  ngOnInit(): void {
  }

  closePopup(): void {
    this.dialogRef.close();
  }


}

interface Program {
  AccountNo: string;
  BBCSprogramID: string;
  JobType: string;
  JobStatus: string;
  JobStatusDate: string;
  JobDesc: string;
  WorkorderId: string;
  ItemDesc: string;
}